module.exports = __webpack_public_path__ + "static/media/mobile.fcebf4c0.ogg";